import styled from 'styled-components';
import {getPrimitive, getSpacing, getFontSize, getFontWeight, tokens} from '@tickchak/react-share/app';
import {dFlexCenter, dFlexColumn} from '../../../../../../globalVariables/GlobalFlex';
import {BGImageCenter, LIGHT_GRAY} from '../../../../../../globalVariables/GlobalVariables';

export const typeCard = styled.button`
    position: relative;
    ${dFlexColumn}
    ${dFlexCenter}
    width: 187px;
    height: 187px;
    border-radius: ${getSpacing('spaceMd')};
    border: 1px solid ${LIGHT_GRAY};
    padding: ${getSpacing('spaceLg')};
    gap: ${getSpacing('spaceLg')};
    background-color: ${LIGHT_GRAY};
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background: ${tokens.color.bg.surface.default};
    }
    &.selected {
    border-radius: 10px;
        background: ${tokens.primitives.turquoise.turquoise100};
        border: 1px solid ${tokens.color.brand.main};
        box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.25);
    }
    &.disabled {
        background: ${tokens.primitives.grays.gray100};
        border-color: ${tokens.color.border.disabled};
        color: ${tokens.color.text.disabled};
        cursor: not-allowed;
        pointer-events: none;
    }
        &>svg {
            align-self: start;
            height: 22px;
    }
`;

export const typeIconWrapper = styled.div<{$icon?: string}>`
    width: 100%;
    height: 100%;
    ${p => p.$icon ? BGImageCenter(p.$icon, 'contain') : ''}
    ${dFlexCenter}
    &.disabled {
        opacity: 0.3;
    }
`;

export const typeLabel = styled.div`
    font-size: ${getFontSize('body')};
    font-weight: ${getFontWeight('medium')};
    color: ${tokens.color.text.subtle};
    align-self: flex-start;
    margin-bottom: auto;
`;

export const checkMarkWrapper = styled.div`
    position: absolute;
    bottom: 12px;
    inset-inline-start: 12px;
    ${dFlexCenter}
`;

export const checkMark = styled.div<{$active?: boolean}>`
    position: relative;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    ${p => p.$active ? `
        background:  ${tokens.primitives.turquoise.turquoise400}80;
        border: 1.5px solid ${tokens.primitives.turquoise.turquoise400};
    `: `
        background: ${LIGHT_GRAY};
        border: 1px solid ${tokens.primitives.grays.gray500};
    `}
    &::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: ${p=>getPrimitive(p.$active? 'turquoise.turquoise400':'grays.gray500')}80;
        transform: translate(-50%, -50%);
    }
`;

export const successCheckMark = styled.div`
    ${dFlexCenter};
    width: 16px;
    height: 16px;
    padding: ${getSpacing('spaceXs')};
    border-radius: 100px;
    background: ${tokens.color.state?.success?.bg || 'var(--color-state-success-bg)'};
`;

export const helperWrapper = styled.div`
    position: absolute;
    top: 12px;
    inset-inline-end: 12px;
    pointer-events: all;
    cursor: pointer;
`;

